<template>
  <div class="image-text-container" :style="{ backgroundColor: containerBgColor }">
    <!-- 左侧图片 -->
    <img :src="imageSrc" class="component-image">
    <!-- 右侧文字区域 -->
    <div class="text-content">
      <!-- 数字行 -->
      <div class="number-text" :style="{ color: textColor }">
        {{ numberValue }}
        <span class="description-text">{{ unitText }}</span>
      </div>
      <!-- 文本行 -->
      <div class="description-text" :style="{ color: textColor }">
        {{ textContent }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

// 定义组件属性，所有内容和样式均可配置
const props = defineProps({
  // 图片相关配置
  imageSrc: {
    type: String,
    required: true,
    description: '左侧图片的URL'
  },
  // 数字相关配置
  numberValue: {
    type: [Number, String],
    required: true,
    description: '上方显示的数字'
  },
  // 文本相关配置
  textContent: {
    type: String,
    required: true,
    description: '下方显示的文本'
  },
  textColor: {
    type: String,
    default: '#666666',
    description: '文本的颜色'
  },
  unitText:{
    type:String,
    default:'项',
    description:'数字右边的单位文字，比如 个、项、元 等'
  }
});
</script>

<style scoped>
.image-text-container {
  display: flex;
  align-items: center;
  max-width: 300px;
  gap: 16px;
  padding: 10px;
  box-sizing: border-box;
}

.component-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  flex-shrink: 0;
}

.text-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.number-text {
  font-family: Microsoft YaHei;
  font-weight: 700;
  font-size: 1.8vw;
  line-height: 1.2;
}

.description-text {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.2;
}
</style>